import { Request } from "./HttpService";

export const AvailabilitiesListService = {
  createAvailabiltiesList(availabilitiesListCandidate) {
    return Request(
      `vitae/availabilitiesList`,
      "POST",
      availabilitiesListCandidate
    );
  },
  updateAvailabiltiesList(availabilitiesListCandidate) {
    return Request(
      `vitae/availabilitiesList`,
      "PUT",
      availabilitiesListCandidate
    );
  },
  deleteAvailabiltiesList(availabilitiesListCandidateId, interviewId) {
    return Request(
      `vitae/availabilitiesList/${availabilitiesListCandidateId}/${interviewId}`,
      "DELETE"
    );
  },
  getAvailabilityList(interviewId) {
    return Request(`vitae/availabilitiesList/${interviewId}`, "GET");
  },
  getContractTypes() {
    return Request("vitae/availabilitiesList/contractTypes", "GET");
  }
};
